export const CITIES = [
  { id: 'la', name: 'Los Angeles', status: 'live', capacity: 8, image: 'https://images.unsplash.com/photo-1587164125082-be88e899b944' },
  { id: 'nyc', name: 'New York City', status: 'coming-soon', capacity: 8, image: 'https://images.unsplash.com/photo-1496442226666-8d4d0e62e6e9' },
  { id: 'atl', name: 'Atlanta', status: 'coming-soon', capacity: 8, image: 'https://images.unsplash.com/photo-1526495124232-a04e1849168c' },
  { id: 'mia', name: 'Miami', status: 'coming-soon', capacity: 8, image: 'https://images.unsplash.com/photo-1506967726964-da9127fdec36' },
  { id: 'lv', name: 'Las Vegas', status: 'coming-soon', capacity: 8, image: 'https://images.unsplash.com/photo-1605833556294-ea5c7a74f57d' },
  { id: 'dal', name: 'Dallas', status: 'coming-soon', capacity: 8, image: 'https://images.unsplash.com/photo-1563751883-dd37498daa03' }
];

export const TRACKS = [
  {
    id: 'product',
    title: 'AI Product Builder',
    description: 'Ship user-facing AI products: chatbots, tools, automations.',
    outcomes: ['Functional MVP', 'User testing', 'Go-to-market plan']
  },
  {
    id: 'content',
    title: 'AI Content + Media',
    description: 'Create AI-powered content systems, newsletters, video workflows.',
    outcomes: ['Content pipeline', 'Audience growth', 'Monetization strategy']
  },
  {
    id: 'ops',
    title: 'AI for Business Ops',
    description: 'Build internal tools, automate workflows, optimize operations.',
    outcomes: ['Automation stack', 'Process docs', 'ROI metrics']
  },
  {
    id: 'engineering',
    title: 'AI Engineering Foundations',
    description: 'Master prompting, APIs, agents, and deployment fundamentals.',
    outcomes: ['Portfolio projects', 'Technical depth', 'Industry connections']
  }
];

export const CURRICULUM_MODULES = [
  { id: 'week1', title: 'Week 1: Foundation & Setup', description: 'Prompt engineering, tool selection, environment setup' },
  { id: 'week2', title: 'Week 2: Building with Agents', description: 'Creating AI agents, API integrations, workflow automation' },
  { id: 'week3', title: 'Week 3: Product Development', description: 'Building MVPs, user testing, iteration cycles' },
  { id: 'week4', title: 'Week 4: Ship & Scale', description: 'Demo day prep, go-to-market, networking, next steps' }
];

export const OUTCOMES = [
  'Build and ship a portfolio of AI projects',
  'Learn practical workflows for modern AI tools',
  'Demo your work to partners and investors',
  'Join a lifelong builder network'
];

export const FAQ_ITEMS = [
  {
    question: 'How long is the program?',
    answer: '4 weeks (one month). Cohorts run quarterly.'
  },
  {
    question: 'Is housing included?',
    answer: 'Yes. You\'ll live with 7 other builders in a fully furnished house.'
  },
  {
    question: 'What\'s the cost?',
    answer: 'Housing is covered. You\'re responsible for food, transportation, and personal expenses.'
  },
  {
    question: 'Do I need coding experience?',
    answer: 'Not necessarily. We have tracks for technical and non-technical builders.'
  },
  {
    question: 'What happens after the program?',
    answer: 'You\'ll have a portfolio, network, and clear next steps—whether that\'s a job, startup, or next project.'
  }
];

export const PARTNER_TIERS = [
  {
    name: 'Starter',
    investment: '$5,000',
    deliverables: ['Logo on website', 'Social media shoutout', 'Talent intro (1 cohort)']
  },
  {
    name: 'Gold',
    investment: '$25,000',
    deliverables: ['All Starter benefits', 'Demo day booth', 'Quarterly talent pipeline', 'Workshop slot']
  },
  {
    name: 'Title',
    investment: '$100,000+',
    deliverables: ['All Gold benefits', 'House naming rights', 'Custom curriculum input', 'Dedicated talent pipeline']
  }
];
